import styled from "styled-components";
import { Color } from "../../styles/Colors";

export const ModalWrapper = styled.div<{ $open?: boolean }>`
  display: ${(props) => (props.$open ? "flex" : "none")};
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99;
  align-items: center;
  justify-content: center;
`;

export const ModalContent = styled.div`
  background-color: ${Color.white};
  padding: 20px;
  border-radius: 5px;
  color: #000;
  width: 500px;
`;

export const ModalHeader = styled.div`
  padding: 10px;
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const ModalBody = styled.div`
  padding: 10px;
  position: relative;
`;

export const ModalFooter = styled.div`
  padding: 10px;
`;

export const CloseButton = styled.button`
  order: 1;
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
  border: none;
  box-shadow: none;
  background: unset;
  &:hover {
    color: black;
  }
`;
